import { createSelector } from '@ngrx/store';

import { AppState } from '../app.state';
import { OffersState } from './offers.reducer';

const selectOffers = createSelector(
  (state: AppState) => state.offers,
  (offers: OffersState) => offers
);

export const selectOffersLoading = createSelector(
  selectOffers,
  (state: OffersState) => state.loading
);

export const selectOffersCount = createSelector(
  selectOffers,
  (state: OffersState) => state.pageOfOffers?.count
);

export const selectOffersResults = createSelector(
  selectOffers,
  (state: OffersState) => state.pageOfOffers?.results
);

export const selectOffersCreateLoading = createSelector(
  selectOffers,
  (state: OffersState) => state.create?.loading
);

export const selectOffersCreateSuccess = createSelector(
  selectOffers,
  (state: OffersState) => state.create?.success
);

export const selectOffersCreateErrors = createSelector(
  selectOffers,
  (state: OffersState) => state.create?.errors
);

export const selectOffersPropertyOffer = createSelector(
  selectOffers,
  (state: OffersState) => state.propertyOffer
);

export const selectOffersWithdraw = createSelector(
  selectOffers,
  (state: OffersState) => state.withdraw
);
